<script>
import { mapActions } from 'vuex'
import utils from '@/utils'

const commonRules = {
  'required-field': {
    required: true,
    message: 'To pole jest wymagane.',
    trigger: 'blur'
  }
}

export default {
  name: 'user-account-edit',
  data () {
    var validateApi = (rule, value, callback, source, options) => {
      if (this.errors[ rule.field ]) {
        this.errors[ rule.field ].forEach(function (message) {
          callback(message)
        })
        delete this.errors[ rule.field ]
      } else {
        callback()
      }
    }

    return {
      account: { ...this.$store.state.account },
      errors: [],
      formChanged: false,
      rules: {
        firstName: [
          commonRules[ 'required-field' ],
          { validator: validateApi, trigger: 'blur' }
        ],
        lastName: [
          commonRules[ 'required-field' ],
          { validator: validateApi, trigger: 'blur' }
        ],
        email: [
          commonRules[ 'required-field' ],
          { type: 'email', message: 'Niepoprawny format adresu email.' },
          { validator: validateApi, trigger: 'blur' }
        ],
        phone: [
          { validator: validateApi, trigger: 'blur' }
        ]
      }
    }
  },
  updated () {
    this.formChanged = true
    this.$refs[ 'account' ]
  },
  methods: {
    ...mapActions([
      'aFetchAccount',
      'aMessageDisplay',
      'aUserAccountChange'
    ]),
    handleSubmit (formName) {
      if (this.formChanged) {
        this.$refs[ formName ].validate((valid) => {
          if (valid) {
            let self = this
            this.aUserAccountChange(this[ formName ])
              .then(() => {
                this.aFetchAccount()
                  .then(() => {
                    this.$emit('update:visible', false)
                  })
                  .catch({})
              })
              .catch((err) => {
                self.errors = utils.keysToCamel(err.body)
                this.$refs[ formName ].validate()
                return false
              })
          } else {
            return false
          }
        })
      } else {
        this.$emit('update:visible', false)
      }
    },
    handleCancel (formName) {
      if (this.formChanged) {
        this.$confirm(
          'Czy na pewno chcesz porzucić wprowadzone zmiany?',
          'Uwaga',
          {
            confirmButtonText: 'Tak',
            cancelButtonText: 'Nie',
            type: 'warning'
          })
          .then(() => {
            this.$emit('update:visible', false)
          })
          .catch({})
      } else {
        this.$emit('update:visible', false)
      }
    }
  }
}
</script>

<template>
  <el-form
    ref="account"
    label-width="120px"
    size="small"
    status-icon
    :model="account"
    :rules="rules"
  >
    <el-form-item
      label="imię"
      prop="firstName"
    >
      <el-input
        placeholder="imię"
        v-model="account.firstName"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="nazwisko"
      prop="lastName"
    >
      <el-input
        placeholder="nazwisko"
        v-model="account.lastName"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="nr telefonu"
      prop="phone"
    >
      <el-input
        placeholder="+48..."
        v-model="account.phone"
        type="email"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <el-button
        type="primary"
        @click="handleSubmit('account')"
      >Zapisz</el-button>
      <el-button
        @click="handleCancel('account')"
        style="float: right; margin: .5rem 0;"
      >
        Anuluj
      </el-button>
    </el-form-item>
  </el-form>
</template>



// WEBPACK FOOTER //
// src/components/user-account-edit.vue